import { registerLocaleData } from '@angular/common';
import localeDe from '@angular/common/locales/de';
import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { environment } from '../../environments/environment';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';


if (environment.production) {
  enableProdMode();
}

registerLocaleData(localeDe);

bootstrapApplication(AppComponent, appConfig)
  .catch(err => console.error(err));

